import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Users, ClipboardCheck, FileCheck2, LogOut } from 'lucide-react';
import './faculty-ui.css';

const navItems = [
  { label: 'Dashboard', path: '/faculty-dashboard', icon: LayoutDashboard },
  { label: 'My Courses', path: '/faculty-dashboard/my-courses', icon: BookOpen },
  { label: 'Students', path: '/faculty-dashboard/students', icon: Users },
  { label: 'Assignments', path: '/faculty-dashboard/students', icon: ClipboardCheck },
  { label: 'Tests', path: '/faculty-dashboard/my-courses', icon: FileCheck2 },
];

export default function Sidebar({ mobileOpen = false, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <>
      <aside className={`faculty-sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="faculty-sidebar-header">
          <BookOpen size={20} color="#4f46e5" />
          <span className="faculty-brand">Faculty</span>
        </div>
        <nav className="faculty-sidebar-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
            return (
              <button key={item.label} className={`faculty-nav-item ${active ? 'active' : ''}`} onClick={() => goTo(item.path)}>
                <Icon size={18} />
                <span className="faculty-nav-label">{item.label}</span>
              </button>
            );
          })}
          <button
            className="faculty-nav-item"
            onClick={() => {
              localStorage.clear();
              window.location.href = '/';
            }}
          >
            <LogOut size={18} />
            <span className="faculty-nav-label">Logout</span>
          </button>
        </nav>
      </aside>
      {mobileOpen ? <button className="faculty-sidebar-overlay" aria-label="Close menu" onClick={onClose} /> : null}
    </>
  );
}
